import React, { useState } from "react"
import CustomButton from "../Atoms/CustomButton"
import CustomDialog from "../Atoms/CustomDialog"
import { withFormController } from "../Molecules/FormController"
import MapAddress from "./MapAddress"
const GoogleMapDialog = ({
  path,
  btnProps,
  disabled,
  children,
  value,
  onChange,
  ...otherProps
}) => {
  const [isOpen, toggleModal] = useState(false)
  const handleClose = () => toggleModal(false)

  const adrLine = value?.village || value?.district || value?.state
  return (
    <>
      <CustomButton
        onClick={e => toggleModal(true)}
        icon="path-search"
        dark={adrLine ? false : true}
        intent={adrLine ? "success" : undefined}
        {...btnProps}
        text={adrLine || btnProps?.text || "Address"}
      />
      <CustomDialog
        className="vt-address-dialog"
        scrollable={false}
        icon="path-search"
        title="Select Address"
        onClose={handleClose}
        isOpen={isOpen}
        light
        footerRightButton={
          <CustomButton
            intent="primary"
            icon="saved"
            text="Save Address"
            onClick={handleClose}
            disabled={disabled}
          />
        }
        {...otherProps}
        width="60%"
      >
        <MapAddress
          value={value}
          onChange={onChange}
          disabled={disabled}
          path={path}
        >
          {children}
        </MapAddress>
      </CustomDialog>
    </>
  )
}
export default withFormController(GoogleMapDialog)
